"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function JoinOurNetworkCTA() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section ref={ref} className="relative bg-background py-24 px-6 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h60v1H0zM0 20h60v1H0zM0 40h60v1H0z' fill='%23000' fill-rule='evenodd'/%3E%3C/svg%3E")`,
      transform: "translateY(calc(var(--scroll-offset, 0) * -0.3px))"
    }} />

      <div className="relative max-w-3xl mx-auto text-center">
        {}
        <div className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-4">
            Join Our Network
          </h2>
          <p className="text-lg md:text-xl text-muted mb-8">Partner with Flex R&amp;D to bring innovative concepts to market faster and more efficiently.</p>
        </div>

        {}
        <div className={`inline-block transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <Link to="/ContactPage">
            <Button size="lg" className="btn-primary relative overflow-hidden group shadow-medium">
              <span className="relative z-10">Become a Partner</span>
              {}
              <span className="absolute inset-0 bg-white/20 scale-0 group-active:scale-100 rounded-md transition-transform duration-300 ease-[var(--ease-spring)]" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}